import { request } from '@/api/_service.js';
export function listCorp(params) {
  return request({
    url: '/erpFaOrgDistributorNew/getFaOrgDistributorListPlatform',
    method: 'get',
    params: params
  });
}